import { Component, Input, OnInit } from '@angular/core';
import { HelpService } from 'src/app/services/help.service';
import { BenefitsByMonth } from '../../models/benefits.models';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-calendar-pay',
  templateUrl: './calendar-pay.component.html',
  styleUrls: ['./calendar-pay.component.scss'],
})
export class CalendarPayComponent implements OnInit {

  @Input() benefitsViews: any;

  benefitsByMonth: BenefitsByMonth[];
  initValue: string;
  mode: string;
  loading: boolean = false;

  values = [
    {
      id: 'next12',
      name: 'Próximos 12 meses',
    },
    {
      id: 'future',
      name: 'Futuros',
    },
    {
      id: 'past',
      name: 'Pasados',
    },
    {
      id: 'all',
      name: this.translate.instant('bid.all'),
    }
  ];

  public searchForm: FormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public errMsgRequired = {};
  public errMsgLogin = {};
  public isSubmit = false;
  public errorLogin = false;

  constructor(private helpService: HelpService, private translate: TranslateService) { }

  ngOnInit() {
    this.benefitsByMonth = this.benefitsViews.next12 && this.benefitsViews.next12.length > 0 ? this.benefitsViews.next12 : this.benefitsViews.future && this.benefitsViews.future.length > 0 ? this.benefitsViews.future : this.benefitsViews.all;
    this.initValue = this.benefitsViews.next12 && this.benefitsViews.next12.length > 0 ? 'next12' : this.benefitsViews.future && this.benefitsViews.future.length > 0 ? 'future' : 'all';
    this.mode = 'list';
    this.searchForm = new FormGroup({
      status: new FormControl('')
    });
  }

  openHelp() {
    this.helpService.openHelp('second', 1, 'PAYMENT_CALENDAR');
  }

  changeMode(mode) {
    this.mode = mode;
  }

  changeProject() {
    this.loading = true;
    this.initValue = this.searchForm.value.status;
    this.benefitsByMonth = this.benefitsViews[this.searchForm.value.status];
    setTimeout(() => {
      this.loading = false;
    }, 400);

  }

}
